export default __webpack_public_path__ + "static/coverYourHome-36524e34ff78676986f03bc4fe3509c2.webp";